import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    document.body.addEventListener('htmx:load', function(evt) {
        if (evt.detail.elt.closest('.noss_offers.default') !== null) {
            let results = evt.detail.elt.closest('.noss_offers.default').querySelectorAll('.items-container .item');
            if (results.length > 0) {
                document.querySelector('#offerbar').classList.remove('empty');
                document.querySelector('#offerbar .found').innerHTML = document.querySelector('#offerbar .found').dataset.text.replace('#NR#', results.length);
            }
            else {
                document.querySelector('#offerbar').classList.add('empty');
            }
            if (!document.querySelector('#offerbar').classList.contains('initalized')) {
                document.querySelector('#offerbar').classList.add('initialized');
            }
        }
    });

    document.querySelector('#offerreset').addEventListener('click', function (event) {
        let resetElements = document.querySelectorAll('.noss_offers.default .filter li.active');
        if (resetElements) {
            for (let i = 0; i < resetElements.length; ++i) {
                if (resetElements[i].closest('.filter').dataset.single == '1') {
                    if (!resetElements[i].classList.contains('active')) {
                        let subElements = resetElements[i].closest('.filter').querySelectorAll('.active');
                        if (subElements) {
                            for (let j = 0; j < subElements.length; ++j) {
                                subElements[j].classList.remove('active');
                                subElements[j].querySelector('[type="hidden"]').value = '';
                            }
                        }
                    }
                }
                else {
                    resetElements[i].classList.add('btn-outline-primary')
                    resetElements[i].classList.remove('btn-primary')
                    resetElements[i].classList.remove('active');
                    resetElements[i].querySelector('[type="hidden"]').value = '';
                }
            }
        }

        // submit request
        let form = document.querySelector('.noss_offers.default form.filters');
        if (form) {
            htmx.trigger(form, 'submit');
        }
    });

    let elements = document.querySelectorAll('.noss_offers.default .filter li');
    if (elements) {
        for (let i = 0; i < elements.length; ++i) {
            elements[i].addEventListener('click', function (event) {
                if (event.target.closest('.filter').dataset.single == '1') {
                    if (!event.target.classList.contains('active')) {
                        let subElements = event.target.closest('.filter').querySelectorAll('.active');
                        if (subElements) {
                            for (let j = 0; j < subElements.length; ++j) {
                                subElements[j].classList.remove('active');
                                subElements[j].querySelector('[type="hidden"]').value = '';
                            }
                        }
                        event.target.classList.add('active');
                        event.target.querySelector('[type="hidden"]').value = event.target.dataset.filter;
                    }
                }
                else {
                    if (event.target.classList.contains('active')) {
                        event.target.classList.add('btn-outline-primary')
                        event.target.classList.remove('btn-primary')
                        event.target.classList.remove('active');
                        event.target.querySelector('[type="hidden"]').value = '';
                    }
                    else {
                        event.target.classList.remove('btn-outline-primary')
                        event.target.classList.add('btn-primary')
                        event.target.classList.add('active');
                        event.target.querySelector('[type="hidden"]').value = event.target.dataset.filter;
                    }
                }

                // submit request
                let form = document.querySelector('.noss_offers.default form.filters');
                if (form) {
                    htmx.trigger(form, 'submit');
                }

            });
        }
    }
}
